import React, { useEffect, useMemo, useRef } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { FormRef, GroupItem, Label, SimpleItem } from "devextreme-react/form";
import ITypeSejour from "../../models/ITypeSejour";
import Guid from "../../models/Guid";
import { FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';
import useEnum from '../../hooks/useEnum';
import GestionCatalogueProduits from '../gestion-catalogue-produits/gestion-catalogue-produits';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionTypesSejoursProps {
  isModeSelection?: boolean,
}

export default function GestionTypesSejours({ isModeSelection }: IGestionTypesSejoursProps) {
  const typesSejoursFormDataSource = useCustomDataSource<ITypeSejour, ITypeSejour>({ path: "typeSejours", primaryKey: "idTypeSejour" });
  const { onFieldDataChanged, setMainForm, setSelectedDataRow: setSelectedTypesSejours, setIsFieldModifier, selectedDataRow: selectedTypeSejour, mode, setMode, isFieldModifier } = typesSejoursFormDataSource;
  const { editorOptions: produitJournalierEditorOption, PopupGestion: PopupGestionCatalogue } =
    useLookUpBase({
      isModeModifier: mode !== Mode.Lecture,
      controllerName: "catalogue",
      showClear: mode !== Mode.Lecture,
      onClearRow: () => {
        setIsFieldModifier(true);
        formRef.current?.instance().updateData("idProduitJournalier", Guid.empty.toString());
      },
      // setDataRow: () => setDataRow("idProduitJournalier"),
      titre: "Catalogue de produits", width: '40%'
    });
  const { editorOptions: modeCalculOptions } = useEnum(undefined, "gestionTypeSejourMOdeCalcul", '20%');
  const { setSelectedValue } = useContextPopupPage();
  // const { catalogueEditorOptions, currentCatalogue, PopupGestionCatalogue } = useCatalogue(true);

  const formRef = useRef<FormRef>(null);

  const descriptionOptions = useMemo(() => {
    return { maxLength: 150 };
  }, []);
  const actifOptions = useMemo(() => {
    return { text: "Actif" };
  }, []);

  const disponibleEnLigneOptions = useMemo(() => {
    return { text: "Disponible en ligne" };
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture)
      formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  const setDataRow = (e: string) => {
    // setSelectedDataRow((prev: ITypeSejour) => (
    //   { ...prev, [e]: Guid.empty.toString() }
    // ));
    // setIsFieldModifier(true);
  }

  // const onSelectionchanged = (item: any, e: string) => {
  // setIsFieldModifier(true);
  // setSelectedDataRow((prev: ITypeSejour) => {
  //   return { ...prev, [e]: item.id }
  // })
  // }

  // console.log(selectedTypeSejour)
  return (
    <FormListBase data={typesSejoursFormDataSource} key={"frm-typesSejours"}>
      <FormListBaseGrid dataSource={typesSejoursFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture)
          }
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}
      >
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedTypeSejour?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture ? <FormListBaseTab>
        <TabItem title="Informations">
          <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedTypeSejour || {} as ITypeSejour} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
            <PopupGestionCatalogue
              onSelectionchanged={(data: any) => {
                setIsFieldModifier(true);
                formRef.current?.instance().updateData("idProduitJournalier", data.idProduit);
              }}
            >
              <GestionCatalogueProduits isModeSelection={true} />
            </PopupGestionCatalogue>

            <GroupItem>
              <GroupItem colCount={2}>
                <SimpleItem key={"frm-description"} dataField={"description"}
                  editorOptions={descriptionOptions} />
                <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
                  editorOptions={actifOptions}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>

              <SimpleItem key={"frm-id-produit-journalier"}
                dataField={"idProduitJournalier"}
                editorOptions={produitJournalierEditorOption}
                editorType={"dxSelectBox"}
              >
                <Label text={"Produit journalier à facturer"} />
              </SimpleItem>
              <SimpleItem key={"frm-mode-calcul"} dataField={"modeCalcul"} editorType={"dxSelectBox"}
                editorOptions={modeCalculOptions}
              >
                <Label text={"Mode de calcul"} />
              </SimpleItem>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Internet">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedTypeSejour || {} as ITypeSejour} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <SimpleItem key={"frm-disponible-en-ligne"} dataField={"disponibleEnLigne"} editorType={"dxCheckBox"}
              editorOptions={disponibleEnLigneOptions}
            >
              <Label visible={false} />
            </SimpleItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedTypeSejour || {} as ITypeSejour} /></TabItem>
      </FormListBaseTab> : null}
    </FormListBase>
  );
}